import { Component, Input } from '@angular/core';
import { SpaContext } from '../../Classes/spacontext';

@Component({
	standalone: false,
	selector: 'signin-method-ehelse',
	template: `
		<p>{{ 'LicenceHolder.Component.EhelseLogin.Title' | translate }}</p>
		<div class="row" *ngIf="eHelseUrl">
			<a [href]="eHelseUrl"
				><button class="btn large">{{ 'Common.Button.SignIn' | translate }}</button></a
			>
		</div>
	`,
})
export class SigninMethodEhelseComponent {
	@Input('ticket') callTicket: Guid | null;
	public eHelseUrl: string | null = null;

	constructor(public spaContext: SpaContext) {
		let url = `${spaContext.baseHref}/?ehelse=true`;
		if (this.callTicket) {
			url += `&callTicket=${this.callTicket}`;
		}
		this.eHelseUrl = url;
	}
}
